import React, { Component, PropTypes } from 'react';

export default class OrganizationDetailShareButtons extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    // Organization id in db
    let db_id = this.props.organization.db_id;

    let fbShareTitle = 'WorldWideWomen | ' + this.props.organization.name;

    let orgUrl = 'https://worldwidewomen.co' +  this.props.routing.locationBeforeTransitions.pathname;

    let twitterText = 'Take%20a%20look%20at%20this%20amazing%20resource%20I%20found%20on WorldWideWomen:%20';



    return(
      <div className="organizationDetail-shareBtn-wrapper">


        <div className="organizationDetail-shareBtn"><a href={'http://twitter.com/share?text=' + twitterText + '&url=' + orgUrl} target="_blank"><i className="fa fa-twitter-square" aria-hidden="true"></i></a></div>

        <div className="organizationDetail-shareBtn"><a title={fbShareTitle} href={'http://www.facebook.com/sharer.php?u=' + orgUrl} target="_blank"><i className="fa fa-facebook-square" aria-hidden="true"></i></a></div>

        <div className="organizationDetail-shareBtn"><a href={'mailto:?subject=Check%20out%20this%20amazing%20resource%20on%20WorldWideWomen&body=Take%20a%20look%20at%20this%20resource%20I%20found%20on%20WorldWideWomen,%20the%20first-ever%20online%20global%20resource%20center%20for%20women%20and%20girls!%20I%20thought%20you%20would%20find%20this%20useful%20:' + orgUrl}><i className="fa fa-envelope-square" aria-hidden="true"></i></a></div>

        <div className="organizationDetail-shareLabel">
          Share via
        </div>

      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/OrganizationDetailShareButtons.jsx